import { LiveAnnouncer } from '@angular/cdk/a11y';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, Injector, Optional, Renderer2, SkipSelf } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material';
import { AiDynamicOverlay } from './dynamic-overlay';

@Injectable()
export class AiDynamicMatSnackBar extends MatSnackBar {

  private dynamicOverlay: AiDynamicOverlay;

  constructor(overlay: AiDynamicOverlay,
              _live: LiveAnnouncer,
              _injector: Injector,
              _breakpointObserver: BreakpointObserver,
              @Optional() @SkipSelf() _parentSnackBar: AiDynamicMatSnackBar,
              _defaultConfig: MatSnackBarConfig) {
    super(overlay, _live, _injector, _breakpointObserver, _parentSnackBar, _defaultConfig);
    this.dynamicOverlay = overlay;
  }

  public setContainerElement(containerElement: HTMLElement, renderer: Renderer2): void {
    // need to apply this styling to make the backdrop with position: fixed styling cover only the containerElement
    renderer.setStyle(containerElement, 'transform', 'translateZ(0)');
    this.dynamicOverlay.setContainerElement(containerElement);
  }
}
